module.exports = __webpack_public_path__ + "img/16.98c9a780.jpeg";